<template>
  <navbar v-if="showNavbar" />
  <router-view/>
  <cookieConsent v-if="showCookie"/>
</template>

<script>
import { defineComponent, watch } from 'vue'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';
import CookieConsent from './components/CookieConsent.vue';
import navbar from './components/navbar.vue';

export default defineComponent({
  components:{navbar, CookieConsent},
  setup() {
    const router = useRouter();
    const showNavbar = ref(true);
    const showCookie = ref(false);

    // The navbar is global now — the only screens without it are the auth
    // screens, which are deliberately a focused single-card layout.
    const NO_NAV = ['signin', 'signup', 'forgot-password'];

    watch(() => router.currentRoute.value.name, (newRoute) => {
      showNavbar.value = !NO_NAV.includes(newRoute);
    }, { immediate: true })

    onMounted(()=>{
      if (!localStorage.getItem("cookieConsent")) {
        showCookie.value = true;
      }
    })

    return {
      router,
      showNavbar,
      showCookie
    }
  },
})
</script>


<style lang="scss">
@import url('./assets/scss/style.scss');
@import url('./assets/scss/theme.scss');
@import url('./assets/scss/tailwind.scss');

body {
    background: var(--tm-canvas);
    color: var(--tm-ink-soft);
}
</style>
